module.exports = __webpack_public_path__ + "static/media/conocephalus_dorsalis_BD_001_APA.1e03c5e7.png";